// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"processActionQueryResult_dialogContent__1OXj3"};